<template>
    <div>
        <TableList
            :columns="columns"
            :get_table_list="this.get_table_list"
            :form_data_seo="form_data_seo"
            :slot_table_list="['operation','all_address','visit_num','order_price','investment_price','binding_num','is_line']"
            ref="list"
            :rowKey="'id'"
        >
		<template slot="all_address" slot-scope="data">
			<span>{{data.record.province}}{{data.record.city}}{{data.record.district}}</span>
		</template>
		
        </TableList>

       
    </div>
</template>

<script>
// @ is an alias to /src
import TableList from "@/components/TableList";
import {getWaterStationList} from "@/api/customer";
const columns = [
    {
        title: "水站名称",
        dataIndex: "name"
    },
    
    {
        title: "客户所属区域",
        dataIndex: "all_address",
		scopedSlots: {
			customRender: "all_address"
		}
    },
	{
	    title: "客户详细地址",
	    dataIndex: "address"
	},
  
    {
        title: "联系人",
        dataIndex: "contact_name"
    },
    {
        title: "联系电话",
        dataIndex: "contact_phone"
    },
	{
	    title: "水站状态",
	    dataIndex: "status_name"
	},
	
];

let status_list = [
    {
        key: 1,
        value: '停用'
    },
    {
        key: 0,
        value: '停用'
    },
	{
	    key: -1,
	    value: '禁用'
	},
];

export default {
    name: "Index",
    components: {
        TableList,
    },
    data() {
        return {
            get_table_list: getWaterStationList,
            columns,
            form_data_seo: {
                list: [
                   
                    {
                        type: "text",
                        name: "keyword",
                        title: "水站名称",
                        placeholder: "水站名称",
                        options: {}
                    },
                    {
                        type: "select",
                        name: "status",
                        title: "水站状态",
                        mode: "default",
                        options: {},
                        list: [
                            {
                                key: 1,
                                value: '启用'
                            },
                            {
                                key: 0,
                                value: '停用'
                            },
                            {
                                key: -1,
                                value: '禁用'
                            },
                        ]
                    },
                   
                ],
                ...this.$config.form_data_seo
            },
            customer_ids: '',
            select_user: [],
        };
    },

    async created() {
        this.$nextTick(() => {
            this.$refs.list.pagination.pageSizeOptions = ['10', '20', '50', '100', '200', '300'];
            this.$refs.list.pagination.showSizeChanger = true;
        })
    },
    methods: {
       
    }
};
</script>

<style lang="less">
@import url("../../assets/less/app.less");
</style>